import ClientClipboard from "./ClientClipboard";
const clientClipboard = new ClientClipboard();
export default clientClipboard;
